import React, { FC, ReactElement } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

interface Feature {
    icon: ReactElement;
    title: string;
    description: string;
}

interface ComposerNxFeatureBlockProps {
    sectionTitle: string;
    features: Feature[];
}

const ComposerNxFeatureBlock: FC<ComposerNxFeatureBlockProps> = ({
    sectionTitle,
    features,
}) => {
    return (
        <SectionContainer>
            <SectionTitle>{sectionTitle}</SectionTitle>
            {features.map((feature, index) => (
                <FeatureItem key={index}>
                    <FeatureTitle>
                        {feature.icon}
                        {feature.title}
                    </FeatureTitle>
                    <FeatureDescription>
                        {feature.description}
                    </FeatureDescription>
                </FeatureItem>
            ))}
        </SectionContainer>
    );
};

const SectionContainer = styled.div(() => ({
    display: 'flex',
    width: aampeTheme.spacing4(80),
    padding: aampeTheme.spacing4(3),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: aampeTheme.spacing4(4),
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.medium,
}));

const SectionTitle = styled.h3(() => ({
    color: aampeTheme.colors.composerNXSectionHeader,
    fontSize: aampeTheme.size.font.textSmall,
    fontWeight: aampeTheme.weights.extraHeavy,
    lineHeight: aampeTheme.size.lineHeight.extraSmall,
    letterSpacing: aampeTheme.spacing4(0.25),
    textTransform: 'uppercase',
    margin: 0,
}));

const FeatureItem = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
}));

const FeatureTitle = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
    color: aampeTheme.colors.composerNXTextDark,
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
    lineHeight: aampeTheme.size.lineHeight.default,
}));

const FeatureDescription = styled.p(() => ({
    color: aampeTheme.colors.composerNXText,
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.light,
    lineHeight: aampeTheme.size.lineHeight.small,
    margin: 0,
    marginLeft: aampeTheme.spacing4(4),
}));

export default ComposerNxFeatureBlock;
